import { render, staticRenderFns } from "./LangMenu.vue?vue&type=template&id=c9111966&"
import script from "./LangMenu.vue?vue&type=script&lang=js&"
export * from "./LangMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports